import { Observable } from 'rxjs';
import { Lieu } from './lieu';
import { TypeLieu } from './type-lieu';

export abstract class LieuRepository {
  abstract getAll(): Observable<Lieu[]>;
  abstract getTypeLieux(): Observable<TypeLieu[]>;
  abstract create(lieu: Lieu): Observable<void>;
  abstract update(lieu: Lieu): Observable<void>;
  abstract delete(id: number): Observable<void>;
}
